import DOMPurify from "dompurify";
import parse from "html-react-parser";

/**
 * Sanitizes an HTML string by removing unsafe markup and attributes that could enable XSS.
 * 
 * Note:
 *  - Rich text editor (Quill) already escapes user-typed angle brackets (`<` and `>`) into
 *    entities such as `&lt;` and `&gt;`, so they remain as plain text
 */
export const sanitize = (html: string): string => {
  if (!html) return "";

  return DOMPurify.sanitize(html);
};

/**
 * Sanitizes an HTML string and converts it into renderable (React) nodes
 */
export const sanitizeForRendering = (html: string | null | undefined) => {
  if (!html) return "";
  return parse(DOMPurify.sanitize(html, { ADD_ATTR: ["target"] }));
};
